import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-068ba859"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header__link_note" }
const _hoisted_2 = {
  key: 0,
  class: "header__info"
}
const _hoisted_3 = { class: "header__info" }
const _hoisted_4 = { class: "header__username text-primary" }
const _hoisted_5 = { class: "text-weight-bold" }

import LogoImg from '~components/LogoImg.vue';
import { getFullNameWithInitials } from '~utils/stringHelpers';
import { useAuthStore } from '@/store/auth/authModule';
import { useOrgsStore } from '@/store/orgs/orgsModule';
import { storeToRefs } from 'pinia';
import { useContractsStore } from '@/store/contracts/contractsModule';
import { Action } from '@/components/TableComponent/types';
import { actionHandler } from '@/actions/actionHandler';

type MenuLink = {
  id: number,
  link: string,
  text: string,
  note?: string,
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const { userName } = storeToRefs(useAuthStore());
const visibleUserName = getFullNameWithInitials(userName.value);

const logout = () => {
  const logoutAction: Action = {
    type: 'custom',
    name: 'logout',
    confirmation: true,
    confirmationText: 'Вы действительно хотите выйти?',
  };
  actionHandler(logoutAction);
};

const menu: MenuLink[] = [
  {
    id: 1,
    link: '/orgs',
    text: 'Организации',
  },
  {
    id: 2,
    link: '/',
    text: 'Договоры',
  },
  {
    id: 3,
    link: '/structure',
    text: 'Сотрудники',
  },
  {
    id: 4,
    link: '/contacts',
    text: 'Контакты',
  },
  {
    id: 5,
    link: '/acts',
    text: 'Акты / Оплаты',
  },
];

const { currentOrg } = storeToRefs(useOrgsStore());
const { currentContract } = storeToRefs(useContractsStore());

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_openBlock(), _createBlock(_component_q_header, { elevated: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, { class: "bg-grey-3" }, {
        default: _withCtx(() => [
          _createVNode(LogoImg),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (item) => {
            return _createVNode(_component_router_link, {
              class: "header__link text-accent",
              key: item.id,
              to: item.link
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  stretch: "",
                  flat: "",
                  label: item.text
                }, null, 8, ["label"]),
                _createElementVNode("span", _hoisted_1, _toDisplayString(item.note ? [item.note] : ''), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          }), 64)),
          _createVNode(_component_q_space),
          (_unref(currentContract)?.id_contract)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(" Договор: " + _toDisplayString(_unref(currentContract)?.id_contract || '') + " ", 1),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(currentContract)?.name_contract), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, " Организация: " + _toDisplayString(_unref(currentOrg).org), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_q_icon, {
              name: "account_circle",
              size: "sm"
            }),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(visibleUserName)), 1)
          ]),
          _createVNode(_component_q_btn, {
            class: "text-accent",
            flat: "",
            icon: "logout",
            label: "Выход",
            onClick: logout
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})